// src/legalVersion.js
// Bump TERMS_VERSION whenever ToS / Privacy Policy / EULA change.
// The version is stored on the user record at registration.
// When it changes, users must re-accept on next login.
export const TERMS_VERSION = "1.0";
export const TERMS_EFFECTIVE_DATE = "April 25, 2026";
